import { render } from "./StripeCheckbout.vue?vue&type=template&id=5648fbf8&scoped=true"
import script from "./StripeCheckbout.vue?vue&type=script&lang=js"
export * from "./StripeCheckbout.vue?vue&type=script&lang=js"

import "./StripeCheckbout.vue?vue&type=style&index=0&id=5648fbf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5648fbf8"]])

export default __exports__